






import {
    Component,
    Prop,
    Vue
} from "vue-property-decorator";
import {
    Action
} from "vuex-class";
import {
    FETCH_PAGE_BY_ID
} from "../store/actions.names";
import {
    pageDataType
} from "../types";
import NImgcard from "@/components/NImgcard.vue";
import NewsTextCard from "@/components/NewsTextCard.vue";
import NewsFullCard from "@/components/NewsFullCard.vue";
@Component({
    name: "NewsAndUpdatePost",
    components: {
        fullImage: NImgcard,
        default: NewsTextCard,
        featured: NewsFullCard
    }
})
export default class NewsAndUpdatePost extends Vue {
    @Action(FETCH_PAGE_BY_ID)[FETCH_PAGE_BY_ID]: any;
    @Prop() item!: pageDataType;
    @Prop() category!: string;
    pageData: pageDataType | null = null;
    mounted() {
        this[FETCH_PAGE_BY_ID]({
            id: this.item.id,
            fields: "*"
        }).then((data: any) => {
            this.pageData = data;
        });
    //   console.log(this.item);
    }
}
